'use strict';

/**
 * Overview for the locations
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var BaseLayout = require('modules/collection/views/layout/base');
var ListViewFactory = require('modules/collection/views/partials/list-factory');
var StoragesListView = require('../partials/storages-list');
var MetaStoragesListView = require('../partials/meta-storages-list');
var ManageStoragesModalView = require('./manage-storages-modal');
var ListControlView = require('modules/collection/views/partials/list-control');
var SearchView = require('modules/global/views/layout/search');

var template = require('modules/collection/modules/location/templates/layout/list.hbs');

var ListLayout = BaseLayout.extend({
    template: template,

    catalog: null,

    collectionStorages: null,
    collectionStoragesNested: null,
    collectionMetaStorages: null,
    collectionUndefined: null,

    regions: {
        storagesRegion: '#regionStorageList',
        metaStoragesRegion: '#regionLocationList',
        notdefinedRegion: '#regionUndefinedList',
        controlsRegion: '.listcontrol-region',
        searchRegion: '.search-region',
    },

    ui: {
        scrollContainer: '.list-layout-scroll-container',
        manageStorage: '[data-action="manage-storages"]',
        containerUndefined: '.container-undefined',
        headerLocation: '.header-location',
        countStorage: '#count-storage',
        countUndefined: '#count-undefined',
    },

    events: {
        'click @ui.manageStorage': 'manageStorage',
    },

    modelEvents: {
        'change:viewMode': 'viewModeChanged',
        'change:sort': 'sortUndefinedCollection',
    },

    initialize: function(options) {
        BaseLayout.prototype.initialize.apply(this, arguments);

        this.catalog = this.getOption('catalog');

        if (this.catalog) {
            this.collectionStorages = this.catalog.storages;
            this.listenTo(this.collectionStorages, 'add remove change sync', function() {
                this.updateCounts();
                if (this.$('.sly-frame').data('sly')) {
                    this.$('.sly-frame').data('sly').reload();
                }
            }.bind(this));

            this.collectionStoragesNested = this.catalog.storages.getNestedCollection();
            this.collectionMetaStorages = this.catalog.storages.getMetaStoragesCollection();

            this.collectionUndefined = this.catalog.objects.getObjectsWithNoStorageCollection();
            this.listenTo(this.collectionUndefined, 'add remove change sync', function(event) {
                this.updateCounts();
            }.bind(this));
        }
    },

    onBeforeShow: function (view, region) {
        // Storages sly
        var viewStorages = new StoragesListView({
            catalog: this.catalog,
            model: this.model,
            collection: this.collectionStoragesNested,
            infiniteView: true,
        });
        this.storagesRegion.show(viewStorages);

        // MetaStorages sly
        var viewMetaStorages = new MetaStoragesListView({
            catalog: this.catalog,
            model: this.model,
            collection: this.collectionMetaStorages,
            infiniteView: true,
            sortDefault: 'name.asc',
        });
        this.metaStoragesRegion.show(viewMetaStorages);

        // Undefined object listing
        this.showListView();

        // Listcontrol for undefined
        this.controlsRegion.show(new ListControlView({
            hasFilter: false,
            viewSwitch: true,
            disableShowroomViewSwitch: true,
            scrollContainer: this.ui.scrollContainer,
            listControlOffsetElements: ['header.content-header', '.locations-list-header'],
            model: this.model,
            collection: this.collectionUndefined,
        }));

        // Show search
        this.searchRegion.show(new SearchView({
            model: this.model,
            collection: this.collectionMetaStorages,
            searchTerms: this.getOption('searchTerms'),
        }));
    },

    onRender: function() {
        this.updateCounts();
    },

    showListView: function() {
        var listViewOptions = {
            lazyRender: true,
            lazyRenderScrollEl: this.ui.scrollContainer,
            lazyRenderPreviousPageThreshold: '65rem',
            scrollContainer: this.ui.scrollContainer,
            activeChildModel: this.model.get('activeModel'),
            model: this.model,
            collection: this.collectionUndefined,
        };

        //@todo check if this need empty view
        // if (_.isFunction(this.getEmptyViewClass)) {
        //     listViewOptions.emptyView = this.getEmptyViewClass();
        // }

        var listViewFactory = new ListViewFactory();
        var listViewType = this.model.get('viewMode');

        var listView = listViewFactory.createListView(listViewType, listViewOptions);

        this.notdefinedRegion.show(listView);
    },

    viewModeChanged: function(model) {
        this.showListView();
    },

    /**
     * Handles the click on the Manage Storage
     */
    manageStorage: function() {
        App.addModal(new ManageStoragesModalView({
            collection: this.collectionStorages,
        }), {additionalClassName: 'modal-left modal-manage-storages'});
    },

    /**
     * Updates the count view variables
     * @return {void}
     */
    updateCounts: function() {
        // Count for storages
        var countStorage = 0;
        this.collectionStoragesNested.each(function(model) {
            countStorage += model.getItemsRecursive().length;
        });
        this.ui.countStorage.html(countStorage);

        // Location count
        var countLocations = [];
        this.collectionMetaStorages.each(function(model) {
            countLocations.push(_.tpl('{name}: {count}', {
                name: model.get('name'),
                count: model.getItemsRecursive().length,
            }));
        }.bind(this));
        this.ui.headerLocation.html(countLocations.join(' / '))

        // Undefined count
        var countUndefined = this.collectionUndefined ? this.collectionUndefined.length : 0;
        this.ui.countUndefined.html(countUndefined);

        // Hide undefined container, if there are no objects
        if (countUndefined === 0) {
            this.ui.containerUndefined.attr('hidden', true);
        } else {
            this.ui.containerUndefined.removeAttr('hidden');
        }
    },

    sortUndefinedCollection: function(model, sort) {
        this.collectionUndefined.sortByFields(sort);
    },
});

module.exports = ListLayout;